import { render, staticRenderFns } from "./messageInfo.vue?vue&type=template&id=f2ed82d4&scoped=true&"
import script from "./messageInfo.vue?vue&type=script&lang=js&"
export * from "./messageInfo.vue?vue&type=script&lang=js&"
import style0 from "./messageInfo.vue?vue&type=style&index=0&id=f2ed82d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ed82d4",
  null
  
)

export default component.exports